
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'Panel',
  props: {
    title: {
      type: String,
      default: '',
    },
    bottom: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { slots }) {
    const hasExtra = computed(() => !!slots.extra);
    return {
      hasExtra,
    };
  },
});
